import React from "react";
import Stage from "../../components/ui/Stages/index";
import Navigate from "../../components/Navigate/index";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumb";
import Alert from "../../components/ui/Alerts/index";
const StartTest = () => {
  return (
    <>
      <BreadCrumb />
      <div className="px-[4px] lg:px-[16px]">
        <Alert value="Sorularınız sadece bir ders ve konudan oluşacaktır." />
      </div>
      <div className="w-100 bg-white rounded-[12px] mx-[4px] lg:mx-[16px] mt-[24px]  lg:px-[16px]">
        <Navigate title="Teste Başlamaya Hazırlanın" />
        <div className="py-[12px] lg:p-[0px] p-[16px] lg:pt-[16px]">
          <div className="flex items-center p-[16px] border-[1px] border-[#E2E8F0] rounded-[16px]">
            <div className="p-[16px] lg:p-[20px] border-[1px] border-[#E2E8F0] rounded-[12px]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
              >
                <path
                  d="M30.3327 23.833H17.3327M21.666 32.4997H17.3327M34.666 15.1663H17.3327M43.3327 14.733V37.2663C43.3327 40.9067 43.3327 42.7269 42.6242 44.1173C42.001 45.3403 41.0067 46.3347 39.7836 46.9579C38.3932 47.6663 36.573 47.6663 32.9327 47.6663H19.066C15.4257 47.6663 13.6055 47.6663 12.2151 46.9579C10.992 46.3347 9.99765 45.3403 9.37447 44.1173C8.66602 42.7269 8.66602 40.9067 8.66602 37.2663V14.733C8.66602 11.0927 8.66602 9.2725 9.37447 7.88207C9.99765 6.65902 10.992 5.66464 12.2151 5.04147C13.6055 4.33301 15.4257 4.33301 19.066 4.33301H32.9327C36.573 4.33301 38.3932 4.33301 39.7836 5.04147C41.0067 5.66464 42.001 6.65902 42.6242 7.88207C43.3327 9.2725 43.3327 11.0927 43.3327 14.733Z"
                  stroke="#E2E8F0"
                  stroke-width="4.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div className="w-[100%] pl-[18px]">
              <h2 className="text-[16px] lg:text-[20px] font-semibold">
                Fonksiyonlar
              </h2>
              <div className="w-[100%] h-[1px] my-[12px] bg-[#D4D4D4]"></div>
              <div className="flex items-center">
                <div className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 25"
                    fill="none"
                    className="svg-icon"
                  >
                    <path
                      d="M21 12.5L9 12.5M21 6.5L9 6.5M21 18.5L9 18.5M5 12.5C5 13.0523 4.55228 13.5 4 13.5C3.44772 13.5 3 13.0523 3 12.5C3 11.9477 3.44772 11.5 4 11.5C4.55228 11.5 5 11.9477 5 12.5ZM5 6.5C5 7.05228 4.55228 7.5 4 7.5C3.44772 7.5 3 7.05228 3 6.5C3 5.94772 3.44772 5.5 4 5.5C4.55228 5.5 5 5.94772 5 6.5ZM5 18.5C5 19.0523 4.55228 19.5 4 19.5C3.44772 19.5 3 19.0523 3 18.5C3 17.9477 3.44772 17.5 4 17.5C4.55228 17.5 5 17.9477 5 18.5Z"
                      stroke="#64748B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <h3 className="text-[#334155] text-[12px] lg:text-[14px] font-semibold pl-[6px]">
                    15 Soru
                  </h3>
                </div>

                <div className="flex items-center pl-[12px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 25"
                    fill="none"
                    className="svg-icon"
                  >
                    <path
                      d="M12 6.5V12.5L16 14.5M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z"
                      stroke="#64748B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <h3 className="text-[#334155] text-[12px] lg:text-[14px] font-semibold pl-[6px]">
                    20 Dakika
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <Stage />
          <div className="flex  mt-[28px]">
            <div className="w-2/4 lg:w-1/4 bg-[#DC2626] rounded-[12px]">
              <button className="w-full flex items-center text-[#FFF] p-[16px]">
                <span className="pr-[10px] text-[14px]">PDF Çıktı Al</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 8.33333L10 12.5M10 12.5L5.83333 8.33333M10 12.5V2.5"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="w-2/4 lg:w-3/4 bg-[#1E293B] rounded-[12px] ml-[12px]">
              <button className="w-full flex items-center justify-between text-[#FFF] p-[16px] text-[14px]">
                Başla
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.16602 10.0003H15.8327M15.8327 10.0003L9.99935 4.16699M15.8327 10.0003L9.99935 15.8337"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StartTest;
